import { ResetFilterButton } from '@/pages/_app/dashboard/ui/reset-filter-button/reset-filter-button'

import { SearchInput } from '@/components/search-input/search-input'
import { SelectFilter } from '@/components/select-filter/select-filter'

import { cn } from '@/lib/utils'

import { useCaseUpdateHistoryFilters } from './use-case-update-history-filters'

export const CaseUpdateHistoryFilters = () => {
  const {
    searchInputText,
    assigneeFilterItems,
    assigneeFilterValues,
    assigneeFilterOption,
    isFilterApplied,
    resetFilter,
    handleChangeSearchInputText,
    handleChangeAssigneeFilterValues,
    handleChangeAssigneeFilterOption,
  } = useCaseUpdateHistoryFilters()

  return (
    <div className={cn('flex gap-x-4')}>
      <SearchInput value={searchInputText} className={{ input: cn('h-9') }} onChange={handleChangeSearchInputText} />

      <div className={cn('flex gap-x-3')}>
        <SelectFilter
          buttonText="Assignee"
          values={assigneeFilterValues}
          items={assigneeFilterItems}
          showsFilterOption
          filterOption={assigneeFilterOption}
          onChangeValue={handleChangeAssigneeFilterValues}
          onChangeFilterOption={handleChangeAssigneeFilterOption}
        />

        {isFilterApplied && <ResetFilterButton onClick={resetFilter} />}
      </div>
    </div>
  )
}
